'use client';

import { CommandPalette, useCommandPalette } from './command-palette';

/**
 * Mounts the global ⌘K command palette and its keyboard listener. Rendered only
 * for super admins (the palette surfaces admin navigation + an org search), so
 * the Cmd/Ctrl+K listener is never attached for regular users.
 */
export function CommandPaletteMount() {
  const { open, setOpen } = useCommandPalette();

  return <CommandPalette open={open} onOpenChange={setOpen} />;
}
